import {isUndefined} from 'lodash';

import {globalDocument} from '../../libs/shared/core/src/helpers/browser/browserHelpers';
import {
  CleanHtml,
  iSolemnlySwearThisHtmlIsClean,
} from '../../libs/shared/core/src/helpers/typescript/cleanHtml';

export interface ImageSize {
  width: number;
  height: number;
}

/** Get the dimensions of the given image file. */
export async function getImageSize(file: File): Promise<ImageSize> {
  const objectUrl = URL.createObjectURL(file);
  try {
    return await new Promise<ImageSize>((resolve, reject) => {
      const image = new Image();
      image.onload = () => {
        const {width, height} = image;
        resolve({width, height});
      };
      image.onerror = () => {
        reject(new Error('Failed to load image from file'));
      };
      image.src = objectUrl;
    });
  } finally {
    // Ensure we don't leak memory.
    URL.revokeObjectURL(objectUrl);
  }
}

export function getInlineImageAttachmentHtml(
  cid: string,
  url: string,
  name: string,
  width?: number,
): CleanHtml {
  // Use an HTMLImageElement to safely generate editor-agnostic HTML for this image.
  const img = globalDocument.createElement('img');
  img.setAttribute('front-cid', cid);
  img.setAttribute('front-name', name);
  img.setAttribute('src', url);

  if (!isUndefined(width)) {
    img.style.width = `${width}px`;
  }

  return iSolemnlySwearThisHtmlIsClean(img.outerHTML);
}
